import { useState } from 'react';
import { mainSiteUrl } from '@/mocks/categories';

const faqs = [
  {
    q: 'What is itaobuyspreadsheet?',
    a: 'itaobuyspreadsheet is a structured sourcing system that helps users find and compare China products efficiently. It organizes verified product listings from Taobao, 1688, and other Chinese platforms into an easy-to-navigate spreadsheet format.',
  },
  {
    q: 'Is itaobuyspreadsheet safe to use?',
    a: 'Yes, itaobuyspreadsheet only provides structured supplier data and verified listings. It does not handle payments or personal financial information. The platform focuses on helping you make informed sourcing decisions with pre-vetted supplier information.',
  },
  {
    q: 'Who should use itaobuyspreadsheet?',
    a: 'itaobuyspreadsheet is ideal for dropshippers, Amazon sellers, Shopify store owners, wholesale buyers, and anyone sourcing products from China who wants to save time, reduce risk, and find better supplier pricing.',
  },
  {
    q: 'How often is the product data updated?',
    a: 'The product database within itaobuyspreadsheet receives regular updates to ensure listings, pricing, and supplier information remain current. This means you are always working with fresh, actionable sourcing data.',
  },
  {
    q: 'How much can I save using itaobuyspreadsheet?',
    a: 'Users of itaobuyspreadsheet typically report saving between 30% and 70% on sourcing costs. These savings come from better supplier price comparison, avoiding middleman markups, and reducing costly purchasing mistakes caused by insufficient research.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100" id="faq">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs tracking-[0.2em] uppercase text-accent-600 font-medium mb-2">
            / FAQ
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-12 md:mt-16">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          Start Using Itaobuyspreadsheet Today
        </h2>
        <p className="text-sm text-foreground-500 mb-6 max-w-md mx-auto">
          Join thousands of buyers optimizing sourcing with structured spreadsheet intelligence.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-excel-2-line text-base"></i>
            Access Spreadsheet Now
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-accent-500 text-accent-600 rounded-full text-sm font-semibold hover:bg-accent-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-base"></i>
            Explore Verified Products
          </a>
        </div>
      </div>
    </section>
  );
}